import Link from 'next/link';
import cn from 'classnames';
import Section from '@/components/commons/Section';
import Slider from '@/components/slider/Slider';

import { breakpoints } from '@/lib/collections/category/helpers';
import Soon from './common/Soon';

const BrandCard = ({
  brand,
  soon = false,
}: {
  brand: string;
  soon?: boolean;
}) => (
  <div
    className={cn(
      'relative flex h-[100px] items-center justify-center rounded-lg bg-gray-300 p-5',
      { 'opacity-50': soon },
    )}
  >
    <h3 className="font-bold">{brand}</h3>

    {soon && <Soon />}
  </div>
);

const ShopByBrand = ({ brands }: { brands: string[] }) => (
  <Section className="reebelo-container pt-8">
    <div>
      <h2 className="flex items-center text-lg font-semibold md:text-xl">
        Shop By Brand
      </h2>
    </div>
    <div className="relative">
      <Slider breakpoints={breakpoints} className="mt-2">
        {brands.map((brand) => (
          <Link href={`/collections/brand/${brand}`} key={brand}>
            <a className="w-full cursor-pointer">
              <BrandCard brand={brand} />
            </a>
          </Link>
        ))}
      </Slider>
    </div>
  </Section>
);

export default ShopByBrand;
